import { confirm } from '../bootbox'

export const FAILED = Symbol('Failed callAsyncWithRetry call')

export const callAsyncWithRetry = async <T>(params: {
  asyncFunction: () => Promise<T>
  actionDescription: string
}): Promise<T | typeof FAILED> => {
  const { asyncFunction, actionDescription } = params
  const result: Awaited<T> | typeof FAILED = await asyncFunction().catch(err => {
    console.error(err?.message ?? err)
    return FAILED
  })

  if (result === FAILED) {
    if (await promptToTryAgain(actionDescription)) {
      return callAsyncWithRetry({ asyncFunction, actionDescription })
    }
  }

  return result
}

async function promptToTryAgain(subject: string): Promise<boolean> {
  return confirm({
    title: `❌ Unable to ${subject || 'process'}`,
    message: `We are sorry, but an error has occurred. Please, try it again or contact <a href="https://feedyou.atlassian.net/servicedesk/customer/portals" target="_blank" rel="noopener noreferrer">our support</a>.`,
    buttons: {
      confirm: {
        label: 'Retry',
        className: 'btn-negative'
      }
    }
  })
}
